export const initialKendoState = {
  sort: [{ field: 'userId', dir: 'asc' }],
  take: 10,
  skip: 0,
};
